import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const HomeTution = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (

    <div>
      <div className="relative h-screen flex flex-col break-words w-full mb-6 shadow-lg bg-white rounded-lg p-8 border-0">
        <div className="flex  gap-2 items-center cursor-pointer" onClick={() => navigate(-1)}>
          <BiArrowBack className="h-5 w-5" />
          <p className="text-[14px]">{t("adminDash.common.back")}</p>
        </div>
        <div className="flex justify-center items-center xl:h-screen h-fit xl:mt-0 mt-16">
          <div className="md:w-[500px] w-full">
            <div className="text-center">
              <p className="text-2xl font-semibold">{t("adminDash.homeTeacherList.title")}</p>
              <p className="text-sm font-normal">{t("adminDash.homeTeacherList.subtitle")}</p>
            </div>

            <div className="flex flex-col mt-5">
              <select
                className="text-[#B5B7C0] text-md cursor-pointer dropdown-select w-full mt-5 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2" >
                <option value="">{t("adminDash.homeTution.selectClass")}</option>
                <option value="math">{t("adminDash.homeTution.math")}</option>
                <option value="science">{t("adminDash.homeTution.science")}</option>
                <option value="history">{t("adminDash.homeTution.history")}</option>
              </select>

              <select
                className="text-[#B5B7C0] text-md cursor-pointer dropdown-select w-full mt-5 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2" >
                <option value="">{t("adminDash.homeTution.selectSubject")}</option>
                <option value="english">{t("adminDash.homeTution.english")}</option>
                <option value="physics">{t("adminDash.homeTution.physics")}</option>
                <option value="chemistry">{t("adminDash.homeTution.chemistry")}</option>
              </select>

              <select
                className="text-[#B5B7C0] text-md cursor-pointer dropdown-select w-full mt-5 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2">
                <option value="">{t("adminDash.homeTution.selectArea")}</option>
                <option value="programming">{t("adminDash.homeTution.programming")}</option>
                <option value="arts">{t("adminDash.homeTution.arts")}</option>
                <option value="music">{t("adminDash.homeTution.music")}</option>
              </select>
            </div>

            <div className="text-center mt-10">

              <Link to='.././homeTeacherList'
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg ml-2 focus:outline-none focus:shadow-outline">
                {t("adminDash.homeTution.findTuition")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTution;
